<template>

    <section>

        <div v-if="flags.loaded">

            <div v-if="flags.sent" id="sent">

                <div class="thanks">
                    <i class="fas fa-check-circle fa-4x text-success mb-15"></i>
                    <p class="lead">{{ $t("reviews.thanks") }}</p>

                    <p><a href="/" class="btn btn-info btn-sm">{{ $t('Volver') }} &raquo;</a></p>
                </div>

            </div>
            <form v-else v-on:submit.prevent="onSubmit" method="post">

                <div class="alert alert-danger" v-if="review.validator.hasError('supplier.id')">
                    {{ review.validator.getError('supplier.id') }}
                </div>

                <div class="form-group" v-bind:class="{ 'has-error' : review.validator.hasError('rate') }">
                    <label for="content" class="control-label">{{ $t("reviews.labels.rate", { supplier : supplier.name } )}}</label>
                    <v-rate ref="rate" v-model="review.rate" @on-change="updateRate"></v-rate>
                </div>

                <div class="form-group" v-bind:class="{ 'has-error' : review.validator.hasError('comment.content') }">
                    <label for="content" class="control-label">{{ $t('reviews.labels.opinion' ) }}</label>
                    <textarea type="text" class="form-control" id="content" v-model="review.comment.content" rows="5"></textarea>
                </div>

                <div class="form-group" v-bind:class="{ 'has-error' : review.validator.hasError('city') }">
                    <label      v-if="supplier.sector.id == 172" for="city" class="control-label">{{ $t('reviews.labels.city_stands')    }}</label>
                    <label v-else-if="supplier.sector.id == 66"  for="city" class="control-label">{{ $t('reviews.labels.city_hostesses') }}</label>
                    <label v-else-if="supplier.sector.id == 79"  for="city" class="control-label">{{ $t('reviews.labels.city_catering')  }}</label>
                    <label v-else                                for="city" class="control-label">{{ $t('reviews.labels.city_stands')    }}</label>

                    <input type="text" class="form-control" id="city" v-model="review.city.name" />
                </div>

                <!--<div class="form-group" v-bind:class="{ 'has-error' : review.validator.hasError('worked_at') }">-->
                    <!--<label for="selectWorkedAt" class="control-label">{{ $t('reviews.labels.worked_at') }}</label>-->
                    <!--<v-select ref="selectWorkedAt" class="form-control" id="selectWorkedAt" v-model="review.worked_at" :options="dateOptions" :allow-clear="true" @on-select="selectWorkedAt"></v-select>-->
                <!--</div>-->

                <div class="form-group" v-bind:class="{ 'has-error' : review.validator.hasError('user.name') }">
                    <label for="user_name" class="control-label">{{ $t('reviews.labels.name' )}}</label>
                    <input type="text" class="form-control" id="user_name" v-model="review.user.name" />
                    <!--<div class="help-block dark">{{ $t('reviews.help.name') }}</div>-->
                </div>

                <div class="form-group" v-bind:class="{ 'has-error' : review.validator.hasError('user.email') }">
                    <label for="user_email" class="control-label">{{ $t('reviews.labels.email' )}}</label>
                    <input type="email" class="form-control" id="user_email" v-model="review.user.email" />
                    <div class="help-block dark">{{ $t('reviews.help.email') }}</div>
                </div>

                <!--<div class="checkbox">-->
                    <!--<label>-->
                        <!--<input type="checkbox" checked v-model="review.anonymous" class="mr-10" />-->

                        <!--{{ $t('reviews.labels.anonymous')}}-->
                    <!--</label>-->
                <!--</div>-->

                <div class="checkbox">
                    <label>
                        <input type="checkbox" checked v-model="accept" required />
                        {{ $t('reviews.labels.accept')}}
                    </label>
                </div>

                <button type="button" class="btn btn-sm" v-bind:class="[enabled ? 'btn-success' : 'btn-default']" :disabled="!enabled" v-on:click="save">
                    {{ $t('reviews.labels.submit')}}
                    <i v-if="flags.sending" class="fal ml-5 fa-spinner fa-spin"></i>
                    <i v-else class="fal ml-5 fa-chevron-right"></i>
                </button>

            </form>

        </div>

        <div v-else id="preloader">
            <div class="loader"></div>
        </div>


        <!-- preload class -->
        <div style="visibility:hidden">
            <span class="fas fa-star"></span>
            <span class="fal fa-spinner"></span>
        </div>

        <v-recaptcha @success="enableForm" :action="'review'" ></v-recaptcha>

    </section>

</template>
<style lang="scss">

    $color-black:  #000;
    $color-yellow: #F2C600;

    .form-group label {

        font-weight: 500;
    }

    textarea.form-control {
        resize: vertical;
    }

    .checkbox {

        margin-bottom: 1em;
        label {
            font-size: 12px;
            padding-left: 40px;
        }

        input[type="checkbox"] {

            position: absolute;
            margin-left: -40px;
            margin-top: 4px \9;
        }
    }

    @keyframes popin{
        0%{
            opacity: 0;
            transform: scale(0);
        }
        1%{
            opacity: 0.1;
            transform: scale(0);
        }
        99%{
            opacity: 0;
            transform: scale(2);
        }
        100%{
            opacity: 0;
            transform: scale(0);
        }
    }

    #preloader {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99999;
        height: 100%;
        width: 100%;
        background: #fff;
        display: flex;

        .loader{
            margin: auto;
            height: 50px;
            width: 50px;
            border-radius: 50%;
            position: relative;
        }

        .loader:before{
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            background: #000;
            border-radius: 50%;
            opacity: 0;
            animation: popin 1.5s linear infinite 0s;
        }

        .loader:after{
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            background: #000;
            border-radius: 50%;
            opacity: 0;
            animation: popin 1.5s linear infinite 0.5s;
        }
    }

    #sent {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99999;
        height: 100%;
        width: 100%;
        background: #fff;
        display: flex;

        .thanks{
            text-align: center;
            margin: auto;
            border-radius: 50%;
            position: relative;
        }
    }

</style>
<script>

    import Supplier from "../../models/Supplier";
    import Review   from "../../models/Review";
    import User     from "../../models/User";
    import Rq       from "../../models/Rq";

    Vue.component('v-recaptcha',     require('./../reCaptchaV3.vue'));
    Vue.component('v-select',        require('./../html/Select2.vue'));
    Vue.component('v-rate',          require('./../rate'));

    export default {

        props : {
            supplier: {
                type: Supplier,
                required : false,
            },

            user: {
                type: User,
                required : false,
            },

            rq: {
                type: Rq,
                required : false,
            },

            recaptcha : {

                type: Object,
                required:false,
            }
        },

        data() {

            return {

                review          : new Review(),
                accept          : 1,
                reviewRateLabel : 0,
                dateOptions     : [],
                enabled         : false,
                flags           : {
                    loaded  : false,
                    sending : false,
                    sent    : false,
                }
            }
        },

        watch : {

            'flags.loaded' : function(newVal, oldVal){

                if(newVal === true){

                    $('#preloader').fadeOut('slow', function() { $(this).remove(); });
                }
            },

            'flags.sent' : function(newVal, oldVal){

                if(newVal === true){

                    let self = this;

                    //setTimeout(function(){/*  window.location.href = self.supplier.permalink;*/}, 1000);
                }
            }
        },

        methods: {

            enableForm(response)
            {
                this.review.score = response.score;
                this.enabled      = true;
            },

            selectWorkedAt(data, e) {

                this.review.worked_at = data.id;
            },

            save() {

                let self      = this,
                    validator = this.review.validate();

                this.flags.sending = true;

                if (validator.hasErrors()) {

                    this.flags.sending = false;

                    console.log(validator.getErrors());

                    return false;
                }

                this.review.save()

                .then(function(){

                    self.flags.sent = true;
                })

                .catch(function(error){

                    console.log(error);
                    alert('An error occurred on save');
                })

                .finally(function(){

                    self.flags.sending = false;

                });

                return false;
            },


            updateRate(rate)
            {
                this.review.rate = rate;
            }
        },

        mounted: function () {

            let option = moment().startOf('month');

            for ( let i = 0; i < 14; i++ ) {

                this.dateOptions.push( { 'id' : option.format('YYYY-MM-DD'), 'text' : option.format('MMMM YYYY') } );

                option.subtract(1, 'month');
            }

            this.review.user         = this.user;
            this.review.rq           = this.rq;
            this.review.site         = 'neventum';
            this.review.target       = this.supplier;
            this.review.target_type  = "App\\Supplier";
            this.flags.loaded        = true;

        },

        created: function () {

            this.reviewRateLabel     = this.review.rate;
            this.review.rate         = parseInt($().getUrlParam('rate', this.review.rate));
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/reviews/supplier.vue